import { Injectable } from '@angular/core';
import { XenaClient } from '../../../services/xena-client/xena-client.service';
import { IOrderLine } from 'src/app/xena-api/dtos';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IListOptionsFilter, defaultListOptionsFilter } from 'src/app/xena-api/filters';
import { IPage } from 'src/app/xena-api/response-types';
import { ContextService } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class OrderLineService extends BaseService<IOrderLine, IListOptionsFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'OrderLine');
  }

  putBulk(orderLines: IOrderLine[]): Observable<IOrderLine[]> {
    const path = `/Fiscal/${this.context.fiscalId}/OrderLine/Bulk`;

    return this.xenaClient.put<IOrderLine[], IOrderLine[]>(path, orderLines);
  }

  getByOrderTask(orderTaskId: number, filter: IListOptionsFilter = defaultListOptionsFilter): Observable<IPage<IOrderLine>> {
    const path = `/Fiscal/${this.context.fiscalId}/OrderTask/${orderTaskId}/OrderLine`;

    return this.xenaClient.list<IOrderLine, IListOptionsFilter>(path, filter);
  }
}
